var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"81cd8be5578482a6f92039e5a8f97168406a8b9d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["trial-lesson-ui@she-inc"]={id:"81cd8be5578482a6f92039e5a8f97168406a8b9d"};
      